import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

type TableHeadStyleProps = {
  cellPadding: string | number;
};

export const useTableHeadStyles = makeStyles<Theme, TableHeadStyleProps>(theme => ({
  actionCell: {
    width: 30,
  },
  autocomplete: {
    width: 250,
  },
  filterChip: {
    margin: 2,
    maxWidth: 400,
  },
  headerCell: {
    whiteSpace: 'nowrap',
    width: 'auto',
    paddingRight: 12,
    backgroundColor: theme.palette.background.paper,
  },
  resizeLine: {
    position: 'absolute',
    height: '100%',
    width: '4px',
    top: 0,
    right: '-2px',
    cursor: 'col-resize',
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    zIndex: 2,
  },
  label: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  searchRow: {
    textAlign: 'right',
    width: '100%',
  },
  sortIcon: {
    verticalAlign: 'middle',
  },
  sortLabel: {
    display: 'inline-block',
    fontSize: 16,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  filterCell: {
    padding: 5,
    top: 41,
    zIndex: 3,
  },
  padding: props => ({ padding: `${props.cellPadding} !important` }),
  firstColumn: {
    zIndex: 3,
  },
}));
